import { useState, type SelectHTMLAttributes, type CSSProperties, type FocusEvent } from "react";
import { useEmbedTokens } from "../theme";

interface Props extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "style"> { invalid?: boolean; }

export function EmbedSelect({ invalid = false, disabled, onFocus, onBlur, children, ...rest }: Props) {
  const t = useEmbedTokens();
  const [focused, setFocused] = useState(false);
  const borderColor = invalid ? t.colors.error : focused ? t.colors.borderFocus : t.colors.border;
  const style: CSSProperties = {
    width: "100%", fontFamily: "inherit", fontSize: t.inputFontSize, color: t.colors.text,
    height: t.buttonHeight, padding: `0 ${t.inputPadding}px`, paddingRight: 36,
    borderRadius: t.borderRadius,
    background: disabled ? t.colors.disabledBg : t.colors.inputBg, border: `1px solid ${borderColor}`,
    outline: "none", boxShadow: focused && !invalid ? `0 0 0 3px ${t.colors.primaryTint}` : "none",
    transition: "border-color .12s, box-shadow .12s", boxSizing: "border-box",
    appearance: "none",
    backgroundImage:
      "linear-gradient(45deg, transparent 50%, " + t.colors.textSecondary + " 50%), " +
      "linear-gradient(135deg, " + t.colors.textSecondary + " 50%, transparent 50%)",
    backgroundPosition: "calc(100% - 18px) 50%, calc(100% - 13px) 50%",
    backgroundSize: "5px 5px, 5px 5px",
    backgroundRepeat: "no-repeat",
  };
  return (
    <select {...rest} disabled={disabled} style={style}
      onFocus={(e: FocusEvent<HTMLSelectElement>) => { setFocused(true); onFocus?.(e); }}
      onBlur={(e: FocusEvent<HTMLSelectElement>) => { setFocused(false); onBlur?.(e); }}>
      {children}
    </select>
  );
}
